import React from "react";
import { useAppSelector } from '../../app/hooks';
import strings, { selectLanguage } from '../../components/localize/localizeSlice';
import { LocalizeSelector } from "../localize/LocalizeSelector";

interface CookieConsentProps {
    onAccept: () => void;
    onDecline: () => void;
    privacyPolicyLink: string;
    imprintLink: string;
}

const CookieConsent: React.FC<CookieConsentProps> = ({
    onAccept,
    privacyPolicyLink,
    imprintLink,
}) => {
    useAppSelector(selectLanguage);

    return (
        <div className="fixed inset-0 bg-gray-900/60  flex justify-center items-center z-50">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 max-w-lg w-full">
                <div className='flex justify-end p-4 w-80 ml-auto'>
                    <LocalizeSelector></LocalizeSelector>
                </div>
                {/* Title */}
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                    {strings.cookieConsent.title}
                </h2>

                {/* Explanation */}
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                    {strings.cookieConsent.explanation}
                    <br></br>
                    <br></br>
                    <a
                        href={privacyPolicyLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline dark:text-blue-400">{privacyPolicyLink}</a>
                    <br></br>
                    <a
                        href={imprintLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline dark:text-blue-400">{imprintLink}</a>
                    <br></br>
                </p>

                {/* Buttons */}
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onAccept}
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-blue-500 dark:hover:bg-blue-600"
                    >
                        {strings.cookieConsent.accept}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;